<template>
  <Wrapper
    v-if="HEADER"
    id="content-view"
    class="h-100 d-flex flex-column section-container content-view"
    :templateColor="templateColor"
    :templateFonts="templateFonts"
    :templateFontsLanguage="templateFontsLanguage"
    :templateBackground="templateBackground"
    :device="detectDevice"
    :customFonts="customFonts"
    :style="{
      '--iframe-scale': iframeScale,
    }"
  >
    <div class="section-body">
      <div v-if="templateMourning && templateMourning.symbol" class="ribbon-mourn d-lg-block d-none" style="width: 128px; height: 128px; position: absolute;top: 0px;left: 0px;z-index: 7;-webkit-backface-visibility: hidden;backface-visibility: hidden;pointer-events: none;">
        <RibbonBand width="148px" height="148px" />
      </div>
      <div v-if="templateMourning && templateMourning.symbol" class="ribbon-mourn d-lg-none" style="width: 100%; height: 100%; top: 0px;left: 0px;-webkit-backface-visibility: hidden;backface-visibility: hidden;pointer-events: none;background-color: #464646;border-bottom: 1px solid white;text-align: center;">
        <Ribbon />
      </div>
      <component
        v-if="siteComponents.HEADER"
        :is="'section_header'"
        :id="siteComponents.HEADER.id"
        v-observe-visibility="visibilityChanged"

      >
      </component>
      <div id="section-content" class="flex-grow-1">
        <div 
          v-if="CONTENT_CONTAINER.componentsID.length == 0 && !preview"
          id="comp-empty_section" 
          style="height:300px;background-color:#f7fbfb;">
          <Overlay
              :detail="{
                name: 'empty_section',
                id: ['component', 'empty_section'],
              }"
              :isOverlay="!preview"
            />
          <div
            v-if="!preview"
            class="
              center-hv
              cursor-pointer
              add-widget-btn
              d-flex
              flex-column
              align-items-center
            "
            style="z-index: 2"
            @click.stop.prevent="addSection"
          >
            <div
              class="icon-btn text-white btn-hover"
            >
              <span class="center-hv">
                <i class="fas fa-plus"></i>
              </span>
            </div>
            <div class="text-muted"> Pick a section to add content here </div>
          </div>
        </div>
        <div
          v-for="section_key in CONTENT_CONTAINER.componentsID"
          :key="`section_key${section_key}`"
          :style="{ position: 'relative' }"
        >
          <DynamicComponent
            v-if="(components[section_key]) && (components[section_key].properties.isEnable == undefined || components[section_key].properties.isEnable)"
            :component_id="section_key"
            :id="'comp-' + section_key"
            v-observe-visibility="visibilityChanged"
          >
            <Overlay
              :detail="{
                name: section_key,
                id: ['component', section_key],
              }"
              :isOverlay="!preview"
            />
          </DynamicComponent>
        </div>
      </div>
      <component
        v-if="siteComponents.FOOTER"
        :is="'section_footer'"
        :id="siteComponents.FOOTER.id"
        v-observe-visibility="visibilityChanged"
      >
      </component>
      <AdsMWE v-if="adsMWE"/>
      <TextEditor />
      <FloatFrameResizeMargin />
      <FloatFrameAddBtn />
      <FloatFrameHover />
      <FloatFrameActive />
      <SectionHover />
      <SectionActive />
      <SlideSectionHover />
      <SlideSectionActive />  
      <SlideContainerHover />
      <SlideContainerActive />
      <CellHover />
      <CellActive />
      <GridHover />
      <GridActive />
      <WidgetActive />
      <WidgetHover />
      <ParentWidgetActive />
      <ImageCrop />
      <SideNavHeaderMenu v-if="detectDevice == 'desktop'"/>
      <SideNavHeaderMenuMobile v-if="detectDevice != 'desktop'"/>
      <ProductFilterMobile v-if="(detectDevice != 'desktop') && isPageAllProduct && isPreview"/>
      <WidgetCommerce v-if="shopSettings.isOpenCommerceWidget"/>
      <WidgetEmbedGoogleReview/>
    </div>
    <div
      v-if="!preview"
      class="dash-line left"
      :style="{ height: '100vh', position: 'fixed' }"
    ></div>
    <div
      v-if="!preview"
      class="dash-line right"
      :style="{ height: '100vh', position: 'fixed' }"
    ></div>
  </Wrapper>
</template>

<script>
import AdsMWE from "@components/AdsMWE/AdsMWE";
import TextEditor from "@components_system/Design/Editor/Quill";
import FloatFrameHover from "@components/tool/FloatFrameHover.vue";
import FloatFrameActive from "@components/tool/FloatFrameActive.vue";
import SectionHover from "@components/dynamic/section/tool/SectionHover.vue";
import SectionActive from "@components/dynamic/section/tool/SectionActive.vue";
import CellHover from "@components/dynamic/cell/tool/CellHover";
import CellActive from "@components/dynamic/cell/tool/CellActive";
import SlideSectionHover from "@components/dynamic/slide_section/tool/SlideSectionHover";
import SlideSectionActive from "@components/dynamic/slide_section/tool/SlideSectionActive";
import SlideContainerHover from "@components/dynamic/slide_container/tool/SlideContainerHover"
import SlideContainerActive from "@components/dynamic/slide_container/tool/SlideContainerActive"
import GridHover from "@shared/components/dynamic/grid/tool/GridHover";
import GridActive from "@shared/components/dynamic/grid/tool/GridActive";
import WidgetHover from "@components/dynamic/widget/tool/WidgetHover";
import WidgetActive from "@components/dynamic/widget/tool/WidgetActive";
import ParentWidgetActive from "@components/dynamic/widget/tool/ParentWidgetActive";
import FloatFrameResizeMargin from "@components/tool/FloatFrameResizeMargin.vue";
import FloatFrameAddBtn from "@components/tool/FloatFrameAddBtn.vue";
import ImageCrop from "@components_system/Design/Sidebar/Shared/Tools/ImageCrop/ImageCrop";
import { mapGetters } from "vuex";
import RegisterdComponents from "@components/RegisterdComponents";
import Overlay from "@components/tool/Overlay";
// import OverlayMain from "@components/tool/OverlayMain";
import { Wrapper } from "./DesignIframe.styled";
import Vue from "vue";
import { ObserveVisibility } from "vue-observe-visibility";
import DynamicComponent from "@components/dynamic/DynamicComponent";
import {
  getComponentMeta,
  findParentTypeComponent,
  mock2Component,
} from "@helpers/component.helper";
Vue.directive("observe-visibility", ObserveVisibility);
const componentsKey = Object.keys(RegisterdComponents);

import hotkeys from "hotkeys-js";

import {
  SECTION,
  GRID,
  CELL,
  WIDGET,
} from "@model/components/componentMeta.model";

import SideNavHeaderMenu from "@components/header/widget/header_widget_menu/sidenav_menu.vue"
import SideNavHeaderMenuMobile from "@components/header/widget/header_widget_menu_mobile/sidenav_menu_mobile.vue";
import ProductFilterMobile from "@components/dynamic/SectionPageProduct/ProductFilterMobile/ProductFilterMobile.vue";
import WidgetCommerce from "@components/dynamic/widget/Ecommerce/Ecommerce";
import RibbonBand from "@components_system/Shared/Images/Website/RibbonBand.vue";
import Ribbon from "@components_system/Shared/Images/Website/Ribbon.vue";
import WidgetEmbedGoogleReview from "@components/dynamic/widget/EmbedGoogleReview/EmbedGoogleReview.vue"
export default {
  components: {
    ...RegisterdComponents,
    DynamicComponent,
    Overlay,
    // OverlayMain,
    Wrapper,
    AdsMWE,
    TextEditor,
    SectionHover,
    SectionActive,
    SlideSectionHover,
    SlideSectionActive,
    SlideContainerHover,
    SlideContainerActive,
    CellHover,
    CellActive,
    ImageCrop,
    GridHover,
    GridActive,
    WidgetHover,
    WidgetActive,
    ParentWidgetActive,
    FloatFrameHover,
    FloatFrameActive,
    FloatFrameResizeMargin,
    FloatFrameAddBtn,
    SideNavHeaderMenu,
    SideNavHeaderMenuMobile,
    ProductFilterMobile,
    WidgetCommerce,
    RibbonBand,
    Ribbon,
    WidgetEmbedGoogleReview,
  },
  computed: {
    ...mapGetters({
      mounted: "mounted",
      iframeScale: "designIframe/iframeScale",
      elHoverID: "designIframe/component/elHoverID",
      elActiveID: "designIframe/component/elActiveID",
      sections: "designIframe/page/sections",
      siteComponents: "designIframe/metadata/siteComponents",
      templateColor: "designIframe/metadata/templateColor",
      templateBackground: "designIframe/metadata/templateBackground",
      templateFonts: "designIframe/metadata/templateFonts",
      templateFontsLanguage: "designIframe/metadata/templateFontsLanguage",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      components: "designIframe/metadata/components",
      toggleHeaderSidenavMenu: "designIframe/toggleHeaderSidenavMenu",
      detectDevice: "detectDevice",
      customFonts: "designIframe/page/customFonts",
      isPreview: "designIframe/preview",
      adsMWE: "designIframe/adsMWE",
      scrollPosition: "scrollPosition",
      sitePageID: "designIframe/metadata/sitePageID",
      siteComponentByID: "designIframe/metadata/siteComponentByID",
      limit: "designIframe/page/limit",
      shopSettings: "designIframe/page/shopSettings",
      templateMourning: "designIframe/metadata/templateMourning",
    }),
    sitePage() {
      return this.siteComponentByID(this.sitePageID) || null;
    },
    isPageAllProduct() {
      return this.sitePage ? this.sitePage.properties.type == 'product_list' : false
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
    styleMenu() {
      return this.siteComponents.HEADER_WIDGET_MENU.style;
    },
    headerMobileLayout() {
      return this.HEADER.styleMobile.layout;
    },
  },
  watch: {
    detectDevice: {
      handler() {
        this.$store.dispatch("designIframe/setToggleHeaderSidenavMenu", false);
      }
    },
    isPreview: {
      handler() {
        this.$store.dispatch("designIframe/setToggleHeaderSidenavMenu", false);
      }
    },
    templateMourning: {
      handler() {
        this.initTemplateMourning();
      },
      deep: true
    }
  },
  data() {
    return {
      preview: false,
      
    };
  },

  mounted() {
    this.initShortkey();
    if (this.$route.hash) {
      const hash = this.$route.hash.split("#");
      const options = hash[1].split("=");
      this.preview = options.indexOf("preview") > -1;
    }
    this.$store.dispatch("designIframe/page/initialiseDesignData", {
      preview: this.preview,
    });
    this.initTemplateMourning();
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.$store.dispatch("designIframe/component/elVisible", {
        // check elemnent is appear
        elementID: entry.target.id,
        visible: isVisible,
      });
    },
    registerHotkeys(key, callback) {
      hotkeys(key, (event) => {
        // Prevent the default refresh event under WINDOWS system
        event.preventDefault();
        callback();
      });
    },
    initShortkey() {
      this.registerHotkeys("command+z,ctrl+z", () =>
        this.$store.dispatch("design/snapshot/undo")
      );
      this.registerHotkeys("ctrl+y,command+y,command+shift+z", () =>
        this.$store.dispatch("design/snapshot/redo")
      );
      this.registerHotkeys("ctrl+c,command+c", () => this.copy());
      this.registerHotkeys("ctrl+v,command+v", () => this.paste());
      // this.registerHotkeys("backspace,del,delete", () => this.delete());
    },
    getDynamicComponent(key) {
      if (componentsKey.indexOf(key) > -1) {
        return key;
      } else {
        return "section_not_exist";
      }
    },

    paste() {
      navigator.clipboard
        .readText()
        .then((text) => {
          try {
            const obj = JSON.parse(text);
            const [type, key] = this.elActiveID;
            if (type == "component") {
              const copyType = obj.render.type;
              const pasteType = getComponentMeta(key);

              if (copyType.priority - pasteType.priority >= -1) {
                if (copyType.priority == SECTION.priority) {
                  this.pasteSection(key, obj);
                } else if (copyType.priority == GRID.priority) {
                  this.pasteComponent(key, obj);
                } else if (copyType.priority == WIDGET.priority) {
                  this.pasteComponent(key, obj);
                }
              }
            }
          } catch (e) {
            console.error(e);
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard contents: ", err);
        });
    },
    delete() {
      const [type, id] = this.elActiveID;

      if (type == "component") {
        const meta = getComponentMeta(id);
        if (meta) {
          if (meta.priority == SECTION.priority) {
            this.$store.dispatch("designIframe/component/removeSection", {
              id,
            });
          } else if (meta.priority == WIDGET.priority) {
            const parentType = findParentTypeComponent(this.components, id);
            const parent = parentType.filter(
              (comp) => comp.type.priority == meta.priority + 1
            )[0];
            this.$store.dispatch("designIframe/component/removeComponent", {
              id,
              parent_id: parent.parent_id,
            });
          } else if (meta.priority == CELL.priority) {
            const parentType = findParentTypeComponent(this.components, id);
            const [grid, cell] = parentType;
            this.$store.dispatch("designIframe/component/removeComponent", {
              id: cell.parent_id,
              parent_id: grid.parent_id,
            });
          }
        }
      }
    },
    copy() {
      const [type, id] = this.elActiveID;
      if (type == "component") {
        this.$store.dispatch("design/component/copyToClipboardComponent", {
          componentID: id,
        });
      }
    },
    pasteSection(pasteKey, insertObject) {
      const parentType = findParentTypeComponent(this.components, pasteKey);
      const { key, object } = mock2Component(
        this.components,
        insertObject.render
      );

      const parent = parentType.filter(
        (comp) => comp.type.priority == SECTION.priority
      )[0];

      // Start Check Limit
      if(object[key].type == "SECTION") {
        if(this.isLimitSection()) { // true = exceed limit section, false = not limit section
          return
        } 
      } else if(object[key].type == "SLIDE_SECTION") {
        if(this.isLimitSlideSection()) {
          return
        }
        if(this.isLimitSection()) { // true = exceed limit section, false = not limit section
          return
        }
      }
      // End Check Limit

      if (parent) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: parent.parent_id,
          },
          path: "/component/addComponent/section",
        });
      } else {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: pasteKey,
          },
          path: "/component/addComponent/section",
        });
      }
      this.$store.commit("designIframe/component/ADD_SECTION", { key, object });
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    pasteComponent(pasteKey, insertObject) {
      const copyType = insertObject.render.type;
      const parentType = findParentTypeComponent(this.components, pasteKey);
      const { key, object } = mock2Component(
        this.components,
        insertObject.render
      );

      const parent = parentType.filter(
        (comp) => comp.type.priority == copyType.priority + 1
      )[0];

      // Start Check Limit
      if(object[key].type == "SECTION_GRID") {
        let sectionID = parent ? parent.parent_id : pasteKey
        if(this.isLimitGrid(sectionID)) { // true = exceed limit grid, false = not limit grid
          return
        } 
      }
      // End Check Limit

      if (parent) {
        this.$store.commit("designIframe/component/ADD_COMPONENT", {
          key,
          object,
          parent_id: parent.parent_id,
          prevIndex: parent.child_index,
        });
      } else {
        this.$store.commit("designIframe/component/ADD_COMPONENT", {
          key,
          object,
          parent_id: pasteKey,
        });
      }
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    isLimitGrid(sectionID) {
      const gridCountInSection = this.components[sectionID].componentsID.length;
      if(!this.limit.grid || gridCountInSection < this.limit.grid) {
        return false
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-grid",
          payload: {},
        });
        return true
      }
    },
    isLimitSection() {
      const sectionInPage = this.CONTENT_CONTAINER.componentsID.length;
      if(!this.limit.section || sectionInPage < this.limit.section) {
        return false
      } else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
        return true
      }
    },
    isLimitSlideSection() {
      const slideSections = Object.keys(this.components)
      .filter(key => key.includes('sec'))
      .reduce((obj, key) => {
        if (this.components[key].type === 'SLIDE_SECTION') obj[key] = this.components[key]
        return obj;
      }, {});
      const slideSectionCountInPage = Object.keys(slideSections).length;
      if(!this.limit.slideSection || slideSectionCountInPage < this.limit.slideSection) { // Check Limit Slide Section
        return false
      } else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-slide-section",
          payload: {},
        });
        return true
      }
    },
    addSection() {
      this.$store.dispatch("design/setMode", { mode: "add_section" });
    },
    initTemplateMourning() {
      try {
        if (this.templateMourning && this.templateMourning.grayscale) {
          document.getElementsByTagName('html')[0].style.setProperty('--style-body-filter-mourning', 'grayscale(60%)');
        }else{
          document.getElementsByTagName('html')[0].style.removeProperty('--style-body-filter-mourning');
        }
      } catch (error) {
        console.error('Error setting template mourning: ', error);
      }
    }
  },
};
</script>

<style global lang="scss">
/* @import url("//fonts.googleapis.com/css?family=Open+Sans:400,700|Playfair+Display|Nunito|Lora|Dancing+Script|Satisfy|Fjalla+One|Oswald|Montserrat|Supermarket|Kunlasatri|Sanchez|Roboto|Quicksand|Pacifico|Raleway|Kanit|Kanit+Light|Prompt|Trirong|Taviraj|Itim|Chonburi|Mitr|Athiti|Pridi|Maitree|Pattaya|Sriracha|Sarabun|Chakra+Petch|Mali|Bai+Jamjuree|Krub|K2D|Niramit|Charm|Srisakdi|Thasadith|Kodchasan|KoHo|Charmonman|Bebas+Neue|Fahkwang&subset=thai,latin"); */
@import "../assets/scss/font-google/font-google.scss";
@import "../assets/css/font.min.css";
@import "../assets/include/hamburgers/hamburgers.min.css";

.render-tool {
  transform: scale(calc(1/var(--iframe-scale))) !important;
  transform-origin: left top;
}
.render-tool-left-bottom {
  transform-origin: left bottom;
}
.render-tool-right-top {
  transform-origin: right top;
}
.render-tool-right-bottom {
  transform-origin: right bottom;
}
.dash-line {
  position: absolute;
  height: 100%;
  width: 1px;
  background-color: #ffffff1f;
  z-index: 3;
  border-left: 1px dashed #808080a8;
}

.icon-btn {
  background-color: #12a9ff;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
  position: relative;
}

.add-widget-btn::hover {
  .btn-hover {
    background-color: #078EDB;
  }
}

/* @media (min-width: 576px) {
  .dash-line.left {
    left: calc((100% - 510px) / 2);
  }
  .dash-line.right {
    right: calc((100% - 510px) / 2);
  }
}
@media (min-width: 768px) {
  .dash-line.left {
    left: calc((100% - 690px) / 2);
  }
  .dash-line.right {
    right: calc((100% - 690px) / 2);
  }
} */
@media (min-width: 1140px) {
  .dash-line.left {
    left: calc((100% - 1110px) / 2);
  }
  .dash-line.right {
    right: calc((100% - 1110px) / 2);
  }
}

html::before {
  content: "";
  position: fixed;
  inset: 0;
  backdrop-filter: var(--style-body-filter-mourning) !important;
  z-index: 999999;
  pointer-events: none;
}
</style>